// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__KnHk1","notes":"Notes_notes__4ZVWz"};